<template>
  <d-card-header class="border-bottom flex-header">
    <ExpenseTableFilters 
      v-model="filters"
      :filters="filters"
      :users="users" 
      :cost-types="costTypes" 
      @filter="handleFilter" 
      @clear="handleClearFilters"
      @userSelected="handleUserSelected"
    />
  </d-card-header>
</template>

<script>
import ExpenseTableFilters from './ExpenseTableFilters.vue';

export default {
  props: {
    users: {
      type: Array,
      required: true
    },
    costTypes: {
      type: Array,
      required: true
    },
    filters: {
      type: Object,
      required: true
    }
  },
  components: { ExpenseTableFilters },
  methods: {
    handleFilter(filters){
      this.$emit('filter', filters)
    },
    handleClearFilters(){
      this.$emit('clear')
    },
    handleUserSelected(userId){
      this.$emit('input', { ...this.filters, user_id: userId.toString() })
    }
  }
}
</script>
